export default function TrustBar() {
  const items = [
    { icon: 'ri-check-double-line', value: '100,000+', label: 'заказов' },
    { icon: 'ri-global-line', value: 'Россия и СНГ', label: 'доставка' },
    { icon: 'ri-shield-check-line', value: 'Безопасные', label: 'платежи' },
    { icon: 'ri-customer-service-2-line', value: '24/7', label: 'поддержка' },
  ];

  return (
    <section className="w-full bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {items.map((item) => (
            <div key={item.label} className="flex flex-col items-center text-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap">
                {item.value}
              </span>
              <span className="text-sm text-foreground-600 whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}